const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKlIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90.31 90.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M80.39,5.14h-69A4.54,4.54,0,0,0,7,9.73V40.78a1.74,1.74,0,1,0,3.48,0v-31a1,1,0,0,1,1-1h69a1,1,0,0,1,1,1v69.5a1,1,0,0,1-1,1h-69a1,1,0,0,1-1-1V54.94A3.37,3.37,0,0,0,8.7,48.75a3.32,3.32,0,0,0-3.27,3.36A3.36,3.36,0,0,0,7,54.94v24.3a4.54,4.54,0,0,0,4.48,4.59h69a4.54,4.54,0,0,0,4.48-4.59V9.73A4.54,4.54,0,0,0,80.39,5.14Z",
    style: {
      fill: "#006098"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.64,60.62V27.25h4.78V42.48h.09l7-15.23h4.78L39.76,40.61l7.74,20H42.44L37,45.81l-2.58,4.83v10Z",
    style: {
      fill: "#0075c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.61,60.62V27.25h4.78V55.84h9.47v4.78Z",
    style: {
      fill: "#0075c9"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKlIcon);
export default __webpack_public_path__ + "static/media/klIcon.90988ac8719f4733a9a32eb77ecbf520.svg";
export { ForwardRef as ReactComponent };